import{__require as r}from"./document-create-element.js";var t,e;function o(){if(e)return t;e=1;var o=r()("span").classList,c=o&&o.constructor&&o.constructor.prototype;return t=c===Object.prototype?void 0:c}export{o as __require};
//# sourceMappingURL=dom-token-list-prototype.js.map
